/**
 * Get 1-2 uppercase initials from a display name.
 *
 * Returns:
 *   - `''` for empty or whitespace-only input (JD WARNING fix — used to
 *     throw `Cannot read properties of undefined (reading 'toUpperCase')`
 *     because it indexed into `parts[0][0]` without a guard).
 *   - The uppercase first letter for a single-token name.
 *   - The uppercase first letter of the first + last token for 2+ tokens
 *     (interior/leading/trailing whitespace collapses via `split(/\s+/)`).
 */
export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (!parts[0]) return '';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
